<template>
  <v-row no-gutters>
    <v-col
      cols="2"
      class="pr-2"
    >
      <v-row
        no-gutters
        align="center"
        :justify="showPrintStatus ? 'space-between' : 'end'"
      >
        <v-icon
          v-if="showPrintStatus"
          x-small
          :color="disabled ? 'grey lighten-1' : 'grey'"
          v-text="icons[`printStatus${printStatus}`]"
        />
        <span v-text="quantity" />
      </v-row>
    </v-col>
    <v-col
      cols="8"
      class="pr-2"
    >
      {{ name }}
      <v-icon
        v-if="menu"
        x-small
        :color="disabled ? 'grey' : 'primary'"
        v-text="icons.menu"
      />
    </v-col>
    <v-col
      cols="2"
      class="text-right"
      :class="{'h-price-paid': paid}"
    >
      {{ (price * quantity) | currency }}
    </v-col>
  </v-row>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Currenciable,
      UsesIcons,
    ],

    props: {
      quantity: {
        required: true,
        type: Number,
      },
      name: {
        required: true,
        type: String,
      },
      price: {
        required: true,
        type: Number,
      },
      printStatus: {
        required: true,
        type: Number,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      closed: {
        required: false,
        type: Boolean,
        default: false,
      },
      menu: {
        required: false,
        type: Boolean,
        default: false,
      },
      paid: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      showPrintStatus () {
        return ! this.closed && this.$page.props.brand === 'HANDY'
      },
    },
  }
</script>
